import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActiveErrorData, InstallationDetailsStore } from '@store';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-floor-heating-over-heating-error',
  templateUrl: './floor-heating-over-heating-error.component.html',
  styleUrls: ['./floor-heating-over-heating-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloorHeatingOverHeatingErrorComponent implements OnInit, OnDestroy {
  installationLocalTimeOfErrorCreatedAt: string;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() floorHeatingOverHeatingError: ActiveErrorData;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private datesService: DatesService
  ) {}

  ngOnInit(): void {
    this.subscribeToTimezone();
  }

  private subscribeToTimezone(): void {
    this.installationDetailsStore.installationTimezone$
      .pipe(
        filter(Boolean),
        map((val: string) => val),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((timeZone) => {
        this.installationLocalTimeOfErrorCreatedAt = this.datesService.getMomentFormattedDateForSpecificTimezone(
          this.floorHeatingOverHeatingError.createdAt,
          timeZone
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
